export default "__VITE_ASSET__1d169f4a__"